import { gql } from '@apollo/client';
const ADD_WAREHOUSE_RELEASE = gql `
  mutation AddWarehouseRelease {
    addWarehouseRelease {
      warehouseRelease {
        id
      }
    }
  }
`;
export default ADD_WAREHOUSE_RELEASE;
